<template>
  <div class="header-cb" v-if="!$route.query.view">
    <div>
      <p><b style="font-size:28px; font-weight: 800;">Performance</b></p>
      <p style="margin-left: 25px; font-size: 16px; color: #666; margin-top: 8px;">ロボパフォーマンス画面</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PerformanceHeader',
  componentName: 'PerformanceHeader',
}
</script>

<style lang="scss" scoped>
.header-cb {
  margin: 10px 20px;
  padding: 15px 10px;
  display: flex;
  justify-content: space-between;
  border-bottom: dotted 6px #323;
}
.header-cb > div {
  display: flex;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Performance/PerformanceHeader.vue